
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("dRjZu"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("4f0mN"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("6xJ3I"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("c3TKb"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("gm4Zl"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("FRhPn"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("9TlbS"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("dJ4VV"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("4Az0z"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("6BqRn"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("9r1Xi"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("a6ADN"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("dRjZu", function(module, exports) {

let $a16fbb5f508eca1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a16fbb5f508eca1f$var$load("2YffH"),
    $a16fbb5f508eca1f$var$load("lMdi0"),
    $a16fbb5f508eca1f$var$load("lqFMg"),
    $a16fbb5f508eca1f$var$load("h4XJj"),
    $a16fbb5f508eca1f$var$load("fEFxJ"),
    $a16fbb5f508eca1f$var$load("iQ0Jm"),
    $a16fbb5f508eca1f$var$load("edaDG"),
    $a16fbb5f508eca1f$var$load("4QkRU"),
    $a16fbb5f508eca1f$var$load("eBRUf"),
    $a16fbb5f508eca1f$var$load("bogQM"),
    $a16fbb5f508eca1f$var$load("jq3Ai"),
    $a16fbb5f508eca1f$var$load("h4Nf7"),
    $a16fbb5f508eca1f$var$load("7f9Fz"),
    $a16fbb5f508eca1f$var$load("8YSo7"),
    $a16fbb5f508eca1f$var$load("dHMdi"),
    $a16fbb5f508eca1f$var$load("lId0W"),
    $a16fbb5f508eca1f$var$load("7do1E"),
    $a16fbb5f508eca1f$var$load("77dkW"),
    $a16fbb5f508eca1f$var$load("g9CVe"),
    $a16fbb5f508eca1f$var$load("3w411"),
    $a16fbb5f508eca1f$var$load("fSobj"),
    $a16fbb5f508eca1f$var$load("74u2y"),
    $a16fbb5f508eca1f$var$load("6wr18"),
    $a16fbb5f508eca1f$var$load("kjZZD"),
    $a16fbb5f508eca1f$var$load("9u7sS"),
    $a16fbb5f508eca1f$var$load("1fem1"),
    $a16fbb5f508eca1f$var$load("kHOMt"),
    $a16fbb5f508eca1f$var$load("dRpV3"),
    $a16fbb5f508eca1f$var$load("ffEVr"),
    $a16fbb5f508eca1f$var$load("kknel"),
    $a16fbb5f508eca1f$var$load("oTvoe"),
    $a16fbb5f508eca1f$var$load("6u1hm"),
    $a16fbb5f508eca1f$var$load("2vAWg"),
    $a16fbb5f508eca1f$var$load("7cABH"),
    $a16fbb5f508eca1f$var$load("4UuEP"),
    $a16fbb5f508eca1f$var$load("dAdaw"),
    $a16fbb5f508eca1f$var$load("2uVTT"),
    $a16fbb5f508eca1f$var$load("1FeuN"),
    $a16fbb5f508eca1f$var$load("lrSMb"),
    $a16fbb5f508eca1f$var$load("hhss7"),
    $a16fbb5f508eca1f$var$load("Wowvf"),
    $a16fbb5f508eca1f$var$load("cJcjb"),
    $a16fbb5f508eca1f$var$load("hJpvQ"),
    $a16fbb5f508eca1f$var$load("bIPPg"),
    $a16fbb5f508eca1f$var$load("lnKog"),
    $a16fbb5f508eca1f$var$load("9ftJe"),
    $a16fbb5f508eca1f$var$load("h3ABO"),
    $a16fbb5f508eca1f$var$load("kC80R"),
    $a16fbb5f508eca1f$var$load("7EorR"),
    $a16fbb5f508eca1f$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("4f0mN", function(module, exports) {

let $3168d8eec2a23f5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3168d8eec2a23f5f$var$load("2YffH"),
    $3168d8eec2a23f5f$var$load("lMdi0"),
    $3168d8eec2a23f5f$var$load("lqFMg"),
    $3168d8eec2a23f5f$var$load("h4XJj"),
    $3168d8eec2a23f5f$var$load("fEFxJ"),
    $3168d8eec2a23f5f$var$load("iQ0Jm"),
    $3168d8eec2a23f5f$var$load("edaDG"),
    $3168d8eec2a23f5f$var$load("4QkRU"),
    $3168d8eec2a23f5f$var$load("eBRUf"),
    $3168d8eec2a23f5f$var$load("bogQM"),
    $3168d8eec2a23f5f$var$load("jq3Ai"),
    $3168d8eec2a23f5f$var$load("h4Nf7"),
    $3168d8eec2a23f5f$var$load("7f9Fz"),
    $3168d8eec2a23f5f$var$load("8YSo7"),
    $3168d8eec2a23f5f$var$load("dHMdi"),
    $3168d8eec2a23f5f$var$load("lId0W"),
    $3168d8eec2a23f5f$var$load("7do1E"),
    $3168d8eec2a23f5f$var$load("77dkW"),
    $3168d8eec2a23f5f$var$load("g9CVe"),
    $3168d8eec2a23f5f$var$load("3w411"),
    $3168d8eec2a23f5f$var$load("fSobj"),
    $3168d8eec2a23f5f$var$load("74u2y"),
    $3168d8eec2a23f5f$var$load("6wr18"),
    $3168d8eec2a23f5f$var$load("kjZZD"),
    $3168d8eec2a23f5f$var$load("9u7sS"),
    $3168d8eec2a23f5f$var$load("1fem1"),
    $3168d8eec2a23f5f$var$load("kHOMt"),
    $3168d8eec2a23f5f$var$load("dRpV3"),
    $3168d8eec2a23f5f$var$load("ffEVr"),
    $3168d8eec2a23f5f$var$load("kknel"),
    $3168d8eec2a23f5f$var$load("oTvoe"),
    $3168d8eec2a23f5f$var$load("6u1hm"),
    $3168d8eec2a23f5f$var$load("2vAWg"),
    $3168d8eec2a23f5f$var$load("7cABH"),
    $3168d8eec2a23f5f$var$load("4UuEP"),
    $3168d8eec2a23f5f$var$load("dAdaw"),
    $3168d8eec2a23f5f$var$load("2uVTT"),
    $3168d8eec2a23f5f$var$load("1FeuN"),
    $3168d8eec2a23f5f$var$load("lrSMb"),
    $3168d8eec2a23f5f$var$load("hhss7"),
    $3168d8eec2a23f5f$var$load("Wowvf"),
    $3168d8eec2a23f5f$var$load("cJcjb"),
    $3168d8eec2a23f5f$var$load("hJpvQ"),
    $3168d8eec2a23f5f$var$load("bIPPg"),
    $3168d8eec2a23f5f$var$load("lnKog"),
    $3168d8eec2a23f5f$var$load("9ftJe"),
    $3168d8eec2a23f5f$var$load("h3ABO"),
    $3168d8eec2a23f5f$var$load("kC80R"),
    $3168d8eec2a23f5f$var$load("7EorR"),
    $3168d8eec2a23f5f$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("6xJ3I", function(module, exports) {

let $4c38c6e7c8dd5d48$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c38c6e7c8dd5d48$var$load("2YffH"),
    $4c38c6e7c8dd5d48$var$load("lMdi0"),
    $4c38c6e7c8dd5d48$var$load("lqFMg"),
    $4c38c6e7c8dd5d48$var$load("h4XJj"),
    $4c38c6e7c8dd5d48$var$load("fEFxJ"),
    $4c38c6e7c8dd5d48$var$load("iQ0Jm"),
    $4c38c6e7c8dd5d48$var$load("edaDG"),
    $4c38c6e7c8dd5d48$var$load("4QkRU"),
    $4c38c6e7c8dd5d48$var$load("eBRUf"),
    $4c38c6e7c8dd5d48$var$load("bogQM"),
    $4c38c6e7c8dd5d48$var$load("jq3Ai"),
    $4c38c6e7c8dd5d48$var$load("h4Nf7"),
    $4c38c6e7c8dd5d48$var$load("7f9Fz"),
    $4c38c6e7c8dd5d48$var$load("8YSo7"),
    $4c38c6e7c8dd5d48$var$load("dHMdi"),
    $4c38c6e7c8dd5d48$var$load("lId0W"),
    $4c38c6e7c8dd5d48$var$load("7do1E"),
    $4c38c6e7c8dd5d48$var$load("77dkW"),
    $4c38c6e7c8dd5d48$var$load("g9CVe"),
    $4c38c6e7c8dd5d48$var$load("3w411"),
    $4c38c6e7c8dd5d48$var$load("fSobj"),
    $4c38c6e7c8dd5d48$var$load("74u2y"),
    $4c38c6e7c8dd5d48$var$load("6wr18"),
    $4c38c6e7c8dd5d48$var$load("kjZZD"),
    $4c38c6e7c8dd5d48$var$load("9u7sS"),
    $4c38c6e7c8dd5d48$var$load("1fem1"),
    $4c38c6e7c8dd5d48$var$load("kHOMt"),
    $4c38c6e7c8dd5d48$var$load("dRpV3"),
    $4c38c6e7c8dd5d48$var$load("ffEVr"),
    $4c38c6e7c8dd5d48$var$load("kknel"),
    $4c38c6e7c8dd5d48$var$load("oTvoe"),
    $4c38c6e7c8dd5d48$var$load("6u1hm"),
    $4c38c6e7c8dd5d48$var$load("2vAWg"),
    $4c38c6e7c8dd5d48$var$load("7cABH"),
    $4c38c6e7c8dd5d48$var$load("4UuEP"),
    $4c38c6e7c8dd5d48$var$load("dAdaw"),
    $4c38c6e7c8dd5d48$var$load("2uVTT"),
    $4c38c6e7c8dd5d48$var$load("1FeuN"),
    $4c38c6e7c8dd5d48$var$load("lrSMb"),
    $4c38c6e7c8dd5d48$var$load("hhss7"),
    $4c38c6e7c8dd5d48$var$load("Wowvf"),
    $4c38c6e7c8dd5d48$var$load("cJcjb"),
    $4c38c6e7c8dd5d48$var$load("hJpvQ"),
    $4c38c6e7c8dd5d48$var$load("bIPPg"),
    $4c38c6e7c8dd5d48$var$load("lnKog"),
    $4c38c6e7c8dd5d48$var$load("9ftJe"),
    $4c38c6e7c8dd5d48$var$load("h3ABO"),
    $4c38c6e7c8dd5d48$var$load("kC80R"),
    $4c38c6e7c8dd5d48$var$load("7EorR"),
    $4c38c6e7c8dd5d48$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("c3TKb", function(module, exports) {

let $8c81016c2d043ebc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8c81016c2d043ebc$var$load("7do1E"),
    $8c81016c2d043ebc$var$load("77dkW"),
    $8c81016c2d043ebc$var$load("2YffH"),
    $8c81016c2d043ebc$var$load("lqFMg"),
    $8c81016c2d043ebc$var$load("h4XJj"),
    $8c81016c2d043ebc$var$load("fEFxJ"),
    $8c81016c2d043ebc$var$load("hJpvQ"),
    $8c81016c2d043ebc$var$load("edaDG"),
    $8c81016c2d043ebc$var$load("eBRUf"),
    $8c81016c2d043ebc$var$load("bogQM"),
    $8c81016c2d043ebc$var$load("jq3Ai"),
    $8c81016c2d043ebc$var$load("h4Nf7"),
    $8c81016c2d043ebc$var$load("7f9Fz"),
    $8c81016c2d043ebc$var$load("8YSo7"),
    $8c81016c2d043ebc$var$load("dHMdi"),
    $8c81016c2d043ebc$var$load("lId0W"),
    $8c81016c2d043ebc$var$load("g9CVe"),
    $8c81016c2d043ebc$var$load("3w411"),
    $8c81016c2d043ebc$var$load("fSobj"),
    $8c81016c2d043ebc$var$load("74u2y"),
    $8c81016c2d043ebc$var$load("6wr18"),
    $8c81016c2d043ebc$var$load("kjZZD"),
    $8c81016c2d043ebc$var$load("9u7sS"),
    $8c81016c2d043ebc$var$load("1fem1"),
    $8c81016c2d043ebc$var$load("kHOMt"),
    $8c81016c2d043ebc$var$load("dRpV3"),
    $8c81016c2d043ebc$var$load("ffEVr"),
    $8c81016c2d043ebc$var$load("kknel"),
    $8c81016c2d043ebc$var$load("oTvoe"),
    $8c81016c2d043ebc$var$load("6u1hm"),
    $8c81016c2d043ebc$var$load("2vAWg"),
    $8c81016c2d043ebc$var$load("7cABH"),
    $8c81016c2d043ebc$var$load("4UuEP"),
    $8c81016c2d043ebc$var$load("dAdaw"),
    $8c81016c2d043ebc$var$load("bIPPg"),
    $8c81016c2d043ebc$var$load("2uVTT"),
    $8c81016c2d043ebc$var$load("1FeuN"),
    $8c81016c2d043ebc$var$load("lrSMb"),
    $8c81016c2d043ebc$var$load("hhss7"),
    $8c81016c2d043ebc$var$load("Wowvf"),
    $8c81016c2d043ebc$var$load("cJcjb"),
    $8c81016c2d043ebc$var$load("9ftJe"),
    $8c81016c2d043ebc$var$load("h3ABO"),
    $8c81016c2d043ebc$var$load("kC80R"),
    $8c81016c2d043ebc$var$load("7EorR"),
    $8c81016c2d043ebc$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("gm4Zl", function(module, exports) {

let $be82920387be3cd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be82920387be3cd0$var$load("7do1E"),
    $be82920387be3cd0$var$load("77dkW"),
    $be82920387be3cd0$var$load("2YffH"),
    $be82920387be3cd0$var$load("lqFMg"),
    $be82920387be3cd0$var$load("h4XJj"),
    $be82920387be3cd0$var$load("fEFxJ"),
    $be82920387be3cd0$var$load("hJpvQ"),
    $be82920387be3cd0$var$load("edaDG"),
    $be82920387be3cd0$var$load("eBRUf"),
    $be82920387be3cd0$var$load("bogQM"),
    $be82920387be3cd0$var$load("jq3Ai"),
    $be82920387be3cd0$var$load("h4Nf7"),
    $be82920387be3cd0$var$load("7f9Fz"),
    $be82920387be3cd0$var$load("8YSo7"),
    $be82920387be3cd0$var$load("dHMdi"),
    $be82920387be3cd0$var$load("lId0W"),
    $be82920387be3cd0$var$load("g9CVe"),
    $be82920387be3cd0$var$load("3w411"),
    $be82920387be3cd0$var$load("fSobj"),
    $be82920387be3cd0$var$load("74u2y"),
    $be82920387be3cd0$var$load("6wr18"),
    $be82920387be3cd0$var$load("kjZZD"),
    $be82920387be3cd0$var$load("9u7sS"),
    $be82920387be3cd0$var$load("1fem1"),
    $be82920387be3cd0$var$load("kHOMt"),
    $be82920387be3cd0$var$load("dRpV3"),
    $be82920387be3cd0$var$load("ffEVr"),
    $be82920387be3cd0$var$load("kknel"),
    $be82920387be3cd0$var$load("oTvoe"),
    $be82920387be3cd0$var$load("6u1hm"),
    $be82920387be3cd0$var$load("2vAWg"),
    $be82920387be3cd0$var$load("7cABH"),
    $be82920387be3cd0$var$load("4UuEP"),
    $be82920387be3cd0$var$load("dAdaw"),
    $be82920387be3cd0$var$load("bIPPg"),
    $be82920387be3cd0$var$load("2uVTT"),
    $be82920387be3cd0$var$load("1FeuN"),
    $be82920387be3cd0$var$load("lrSMb"),
    $be82920387be3cd0$var$load("hhss7"),
    $be82920387be3cd0$var$load("Wowvf"),
    $be82920387be3cd0$var$load("cJcjb"),
    $be82920387be3cd0$var$load("9ftJe"),
    $be82920387be3cd0$var$load("h3ABO"),
    $be82920387be3cd0$var$load("kC80R"),
    $be82920387be3cd0$var$load("7EorR"),
    $be82920387be3cd0$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("FRhPn", function(module, exports) {

let $07dd2a0c34eb9163$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $07dd2a0c34eb9163$var$load("7do1E"),
    $07dd2a0c34eb9163$var$load("77dkW"),
    $07dd2a0c34eb9163$var$load("2YffH"),
    $07dd2a0c34eb9163$var$load("lqFMg"),
    $07dd2a0c34eb9163$var$load("h4XJj"),
    $07dd2a0c34eb9163$var$load("fEFxJ"),
    $07dd2a0c34eb9163$var$load("hJpvQ"),
    $07dd2a0c34eb9163$var$load("edaDG"),
    $07dd2a0c34eb9163$var$load("eBRUf"),
    $07dd2a0c34eb9163$var$load("bogQM"),
    $07dd2a0c34eb9163$var$load("jq3Ai"),
    $07dd2a0c34eb9163$var$load("h4Nf7"),
    $07dd2a0c34eb9163$var$load("7f9Fz"),
    $07dd2a0c34eb9163$var$load("8YSo7"),
    $07dd2a0c34eb9163$var$load("dHMdi"),
    $07dd2a0c34eb9163$var$load("lId0W"),
    $07dd2a0c34eb9163$var$load("g9CVe"),
    $07dd2a0c34eb9163$var$load("3w411"),
    $07dd2a0c34eb9163$var$load("fSobj"),
    $07dd2a0c34eb9163$var$load("74u2y"),
    $07dd2a0c34eb9163$var$load("6wr18"),
    $07dd2a0c34eb9163$var$load("kjZZD"),
    $07dd2a0c34eb9163$var$load("9u7sS"),
    $07dd2a0c34eb9163$var$load("1fem1"),
    $07dd2a0c34eb9163$var$load("kHOMt"),
    $07dd2a0c34eb9163$var$load("dRpV3"),
    $07dd2a0c34eb9163$var$load("ffEVr"),
    $07dd2a0c34eb9163$var$load("kknel"),
    $07dd2a0c34eb9163$var$load("oTvoe"),
    $07dd2a0c34eb9163$var$load("6u1hm"),
    $07dd2a0c34eb9163$var$load("2vAWg"),
    $07dd2a0c34eb9163$var$load("7cABH"),
    $07dd2a0c34eb9163$var$load("4UuEP"),
    $07dd2a0c34eb9163$var$load("dAdaw"),
    $07dd2a0c34eb9163$var$load("bIPPg"),
    $07dd2a0c34eb9163$var$load("2uVTT"),
    $07dd2a0c34eb9163$var$load("1FeuN"),
    $07dd2a0c34eb9163$var$load("lrSMb"),
    $07dd2a0c34eb9163$var$load("hhss7"),
    $07dd2a0c34eb9163$var$load("Wowvf"),
    $07dd2a0c34eb9163$var$load("cJcjb"),
    $07dd2a0c34eb9163$var$load("9ftJe"),
    $07dd2a0c34eb9163$var$load("h3ABO"),
    $07dd2a0c34eb9163$var$load("kC80R"),
    $07dd2a0c34eb9163$var$load("7EorR"),
    $07dd2a0c34eb9163$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("9TlbS", function(module, exports) {

let $7339b01d401b9fef$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7339b01d401b9fef$var$load("7do1E"),
    $7339b01d401b9fef$var$load("77dkW"),
    $7339b01d401b9fef$var$load("2YffH"),
    $7339b01d401b9fef$var$load("lqFMg"),
    $7339b01d401b9fef$var$load("h4XJj"),
    $7339b01d401b9fef$var$load("fEFxJ"),
    $7339b01d401b9fef$var$load("edaDG"),
    $7339b01d401b9fef$var$load("eBRUf"),
    $7339b01d401b9fef$var$load("bogQM"),
    $7339b01d401b9fef$var$load("jq3Ai"),
    $7339b01d401b9fef$var$load("h4Nf7"),
    $7339b01d401b9fef$var$load("7f9Fz"),
    $7339b01d401b9fef$var$load("8YSo7"),
    $7339b01d401b9fef$var$load("dHMdi"),
    $7339b01d401b9fef$var$load("lId0W"),
    $7339b01d401b9fef$var$load("g9CVe"),
    $7339b01d401b9fef$var$load("3w411"),
    $7339b01d401b9fef$var$load("fSobj"),
    $7339b01d401b9fef$var$load("74u2y"),
    $7339b01d401b9fef$var$load("6wr18"),
    $7339b01d401b9fef$var$load("kjZZD"),
    $7339b01d401b9fef$var$load("9u7sS"),
    $7339b01d401b9fef$var$load("1fem1"),
    $7339b01d401b9fef$var$load("kHOMt"),
    $7339b01d401b9fef$var$load("dRpV3"),
    $7339b01d401b9fef$var$load("ffEVr"),
    $7339b01d401b9fef$var$load("kknel"),
    $7339b01d401b9fef$var$load("oTvoe"),
    $7339b01d401b9fef$var$load("6u1hm"),
    $7339b01d401b9fef$var$load("2vAWg"),
    $7339b01d401b9fef$var$load("7cABH"),
    $7339b01d401b9fef$var$load("4UuEP"),
    $7339b01d401b9fef$var$load("dAdaw"),
    $7339b01d401b9fef$var$load("2uVTT"),
    $7339b01d401b9fef$var$load("1FeuN"),
    $7339b01d401b9fef$var$load("lrSMb"),
    $7339b01d401b9fef$var$load("hhss7"),
    $7339b01d401b9fef$var$load("Wowvf"),
    $7339b01d401b9fef$var$load("cJcjb"),
    $7339b01d401b9fef$var$load("hJpvQ"),
    $7339b01d401b9fef$var$load("bIPPg"),
    $7339b01d401b9fef$var$load("lnKog"),
    $7339b01d401b9fef$var$load("9ftJe"),
    $7339b01d401b9fef$var$load("h3ABO"),
    $7339b01d401b9fef$var$load("kC80R"),
    $7339b01d401b9fef$var$load("7EorR"),
    $7339b01d401b9fef$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("dJ4VV", function(module, exports) {

let $9fe34df8e4704a89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9fe34df8e4704a89$var$load("2YffH"),
    $9fe34df8e4704a89$var$load("lqFMg"),
    $9fe34df8e4704a89$var$load("h4XJj"),
    $9fe34df8e4704a89$var$load("fEFxJ"),
    $9fe34df8e4704a89$var$load("edaDG"),
    $9fe34df8e4704a89$var$load("4QkRU"),
    $9fe34df8e4704a89$var$load("eBRUf"),
    $9fe34df8e4704a89$var$load("bogQM"),
    $9fe34df8e4704a89$var$load("jq3Ai"),
    $9fe34df8e4704a89$var$load("h4Nf7"),
    $9fe34df8e4704a89$var$load("7f9Fz"),
    $9fe34df8e4704a89$var$load("8YSo7"),
    $9fe34df8e4704a89$var$load("dHMdi"),
    $9fe34df8e4704a89$var$load("lId0W"),
    $9fe34df8e4704a89$var$load("7do1E"),
    $9fe34df8e4704a89$var$load("77dkW"),
    $9fe34df8e4704a89$var$load("g9CVe"),
    $9fe34df8e4704a89$var$load("3w411"),
    $9fe34df8e4704a89$var$load("fSobj"),
    $9fe34df8e4704a89$var$load("74u2y"),
    $9fe34df8e4704a89$var$load("6wr18"),
    $9fe34df8e4704a89$var$load("kjZZD"),
    $9fe34df8e4704a89$var$load("9u7sS"),
    $9fe34df8e4704a89$var$load("1fem1"),
    $9fe34df8e4704a89$var$load("kHOMt"),
    $9fe34df8e4704a89$var$load("dRpV3"),
    $9fe34df8e4704a89$var$load("ffEVr"),
    $9fe34df8e4704a89$var$load("dTsOE"),
    $9fe34df8e4704a89$var$load("kknel"),
    $9fe34df8e4704a89$var$load("oTvoe"),
    $9fe34df8e4704a89$var$load("6u1hm"),
    $9fe34df8e4704a89$var$load("2vAWg"),
    $9fe34df8e4704a89$var$load("7cABH"),
    $9fe34df8e4704a89$var$load("4UuEP"),
    $9fe34df8e4704a89$var$load("dAdaw"),
    $9fe34df8e4704a89$var$load("2uVTT"),
    $9fe34df8e4704a89$var$load("1FeuN"),
    $9fe34df8e4704a89$var$load("lrSMb"),
    $9fe34df8e4704a89$var$load("hhss7"),
    $9fe34df8e4704a89$var$load("Wowvf"),
    $9fe34df8e4704a89$var$load("cJcjb"),
    $9fe34df8e4704a89$var$load("hJpvQ"),
    $9fe34df8e4704a89$var$load("bIPPg"),
    $9fe34df8e4704a89$var$load("lnKog"),
    $9fe34df8e4704a89$var$load("9ftJe"),
    $9fe34df8e4704a89$var$load("h3ABO"),
    $9fe34df8e4704a89$var$load("kC80R"),
    $9fe34df8e4704a89$var$load("7EorR"),
    $9fe34df8e4704a89$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("4Az0z", function(module, exports) {

let $3575ae1dea9411a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3575ae1dea9411a1$var$load("2YffH"),
    $3575ae1dea9411a1$var$load("lqFMg"),
    $3575ae1dea9411a1$var$load("h4XJj"),
    $3575ae1dea9411a1$var$load("fEFxJ"),
    $3575ae1dea9411a1$var$load("edaDG"),
    $3575ae1dea9411a1$var$load("4QkRU"),
    $3575ae1dea9411a1$var$load("eBRUf"),
    $3575ae1dea9411a1$var$load("bogQM"),
    $3575ae1dea9411a1$var$load("jq3Ai"),
    $3575ae1dea9411a1$var$load("h4Nf7"),
    $3575ae1dea9411a1$var$load("7f9Fz"),
    $3575ae1dea9411a1$var$load("8YSo7"),
    $3575ae1dea9411a1$var$load("dHMdi"),
    $3575ae1dea9411a1$var$load("lId0W"),
    $3575ae1dea9411a1$var$load("7do1E"),
    $3575ae1dea9411a1$var$load("77dkW"),
    $3575ae1dea9411a1$var$load("g9CVe"),
    $3575ae1dea9411a1$var$load("3w411"),
    $3575ae1dea9411a1$var$load("fSobj"),
    $3575ae1dea9411a1$var$load("74u2y"),
    $3575ae1dea9411a1$var$load("6wr18"),
    $3575ae1dea9411a1$var$load("kjZZD"),
    $3575ae1dea9411a1$var$load("9u7sS"),
    $3575ae1dea9411a1$var$load("1fem1"),
    $3575ae1dea9411a1$var$load("kHOMt"),
    $3575ae1dea9411a1$var$load("dRpV3"),
    $3575ae1dea9411a1$var$load("ffEVr"),
    $3575ae1dea9411a1$var$load("dTsOE"),
    $3575ae1dea9411a1$var$load("kknel"),
    $3575ae1dea9411a1$var$load("oTvoe"),
    $3575ae1dea9411a1$var$load("6u1hm"),
    $3575ae1dea9411a1$var$load("2vAWg"),
    $3575ae1dea9411a1$var$load("7cABH"),
    $3575ae1dea9411a1$var$load("4UuEP"),
    $3575ae1dea9411a1$var$load("dAdaw"),
    $3575ae1dea9411a1$var$load("2uVTT"),
    $3575ae1dea9411a1$var$load("1FeuN"),
    $3575ae1dea9411a1$var$load("lrSMb"),
    $3575ae1dea9411a1$var$load("hhss7"),
    $3575ae1dea9411a1$var$load("Wowvf"),
    $3575ae1dea9411a1$var$load("cJcjb"),
    $3575ae1dea9411a1$var$load("hJpvQ"),
    $3575ae1dea9411a1$var$load("bIPPg"),
    $3575ae1dea9411a1$var$load("lnKog"),
    $3575ae1dea9411a1$var$load("9ftJe"),
    $3575ae1dea9411a1$var$load("h3ABO"),
    $3575ae1dea9411a1$var$load("kC80R"),
    $3575ae1dea9411a1$var$load("7EorR"),
    $3575ae1dea9411a1$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("6BqRn", function(module, exports) {

let $4ceb08986ccc5cf6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4ceb08986ccc5cf6$var$load("7do1E"),
    $4ceb08986ccc5cf6$var$load("77dkW"),
    $4ceb08986ccc5cf6$var$load("2YffH"),
    $4ceb08986ccc5cf6$var$load("lqFMg"),
    $4ceb08986ccc5cf6$var$load("h4XJj"),
    $4ceb08986ccc5cf6$var$load("fEFxJ"),
    $4ceb08986ccc5cf6$var$load("hJpvQ"),
    $4ceb08986ccc5cf6$var$load("edaDG"),
    $4ceb08986ccc5cf6$var$load("eBRUf"),
    $4ceb08986ccc5cf6$var$load("bogQM"),
    $4ceb08986ccc5cf6$var$load("jq3Ai"),
    $4ceb08986ccc5cf6$var$load("h4Nf7"),
    $4ceb08986ccc5cf6$var$load("7f9Fz"),
    $4ceb08986ccc5cf6$var$load("8YSo7"),
    $4ceb08986ccc5cf6$var$load("dHMdi"),
    $4ceb08986ccc5cf6$var$load("lId0W"),
    $4ceb08986ccc5cf6$var$load("g9CVe"),
    $4ceb08986ccc5cf6$var$load("3w411"),
    $4ceb08986ccc5cf6$var$load("fSobj"),
    $4ceb08986ccc5cf6$var$load("74u2y"),
    $4ceb08986ccc5cf6$var$load("6wr18"),
    $4ceb08986ccc5cf6$var$load("kjZZD"),
    $4ceb08986ccc5cf6$var$load("9u7sS"),
    $4ceb08986ccc5cf6$var$load("1fem1"),
    $4ceb08986ccc5cf6$var$load("kHOMt"),
    $4ceb08986ccc5cf6$var$load("dRpV3"),
    $4ceb08986ccc5cf6$var$load("ffEVr"),
    $4ceb08986ccc5cf6$var$load("kknel"),
    $4ceb08986ccc5cf6$var$load("oTvoe"),
    $4ceb08986ccc5cf6$var$load("6u1hm"),
    $4ceb08986ccc5cf6$var$load("2vAWg"),
    $4ceb08986ccc5cf6$var$load("7cABH"),
    $4ceb08986ccc5cf6$var$load("4UuEP"),
    $4ceb08986ccc5cf6$var$load("dAdaw"),
    $4ceb08986ccc5cf6$var$load("bIPPg"),
    $4ceb08986ccc5cf6$var$load("2uVTT"),
    $4ceb08986ccc5cf6$var$load("1FeuN"),
    $4ceb08986ccc5cf6$var$load("lrSMb"),
    $4ceb08986ccc5cf6$var$load("hhss7"),
    $4ceb08986ccc5cf6$var$load("Wowvf"),
    $4ceb08986ccc5cf6$var$load("cJcjb"),
    $4ceb08986ccc5cf6$var$load("9ftJe"),
    $4ceb08986ccc5cf6$var$load("h3ABO"),
    $4ceb08986ccc5cf6$var$load("kC80R"),
    $4ceb08986ccc5cf6$var$load("7EorR"),
    $4ceb08986ccc5cf6$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("9r1Xi", function(module, exports) {

let $6de826fb0ca46c7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6de826fb0ca46c7e$var$load("7do1E"),
    $6de826fb0ca46c7e$var$load("77dkW"),
    $6de826fb0ca46c7e$var$load("2YffH"),
    $6de826fb0ca46c7e$var$load("lqFMg"),
    $6de826fb0ca46c7e$var$load("h4XJj"),
    $6de826fb0ca46c7e$var$load("fEFxJ"),
    $6de826fb0ca46c7e$var$load("edaDG"),
    $6de826fb0ca46c7e$var$load("eBRUf"),
    $6de826fb0ca46c7e$var$load("bogQM"),
    $6de826fb0ca46c7e$var$load("jq3Ai"),
    $6de826fb0ca46c7e$var$load("h4Nf7"),
    $6de826fb0ca46c7e$var$load("7f9Fz"),
    $6de826fb0ca46c7e$var$load("8YSo7"),
    $6de826fb0ca46c7e$var$load("dHMdi"),
    $6de826fb0ca46c7e$var$load("lId0W"),
    $6de826fb0ca46c7e$var$load("g9CVe"),
    $6de826fb0ca46c7e$var$load("3w411"),
    $6de826fb0ca46c7e$var$load("fSobj"),
    $6de826fb0ca46c7e$var$load("74u2y"),
    $6de826fb0ca46c7e$var$load("6wr18"),
    $6de826fb0ca46c7e$var$load("kjZZD"),
    $6de826fb0ca46c7e$var$load("9u7sS"),
    $6de826fb0ca46c7e$var$load("1fem1"),
    $6de826fb0ca46c7e$var$load("kHOMt"),
    $6de826fb0ca46c7e$var$load("dRpV3"),
    $6de826fb0ca46c7e$var$load("ffEVr"),
    $6de826fb0ca46c7e$var$load("kknel"),
    $6de826fb0ca46c7e$var$load("oTvoe"),
    $6de826fb0ca46c7e$var$load("6u1hm"),
    $6de826fb0ca46c7e$var$load("2vAWg"),
    $6de826fb0ca46c7e$var$load("7cABH"),
    $6de826fb0ca46c7e$var$load("4UuEP"),
    $6de826fb0ca46c7e$var$load("dAdaw"),
    $6de826fb0ca46c7e$var$load("2uVTT"),
    $6de826fb0ca46c7e$var$load("1FeuN"),
    $6de826fb0ca46c7e$var$load("lrSMb"),
    $6de826fb0ca46c7e$var$load("hhss7"),
    $6de826fb0ca46c7e$var$load("Wowvf"),
    $6de826fb0ca46c7e$var$load("cJcjb"),
    $6de826fb0ca46c7e$var$load("hJpvQ"),
    $6de826fb0ca46c7e$var$load("bIPPg"),
    $6de826fb0ca46c7e$var$load("lnKog"),
    $6de826fb0ca46c7e$var$load("9ftJe"),
    $6de826fb0ca46c7e$var$load("h3ABO"),
    $6de826fb0ca46c7e$var$load("kC80R"),
    $6de826fb0ca46c7e$var$load("7EorR"),
    $6de826fb0ca46c7e$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("a6ADN", function(module, exports) {

let $75b6e30d7ac36fcf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $75b6e30d7ac36fcf$var$load("7do1E"),
    $75b6e30d7ac36fcf$var$load("77dkW"),
    $75b6e30d7ac36fcf$var$load("2YffH"),
    $75b6e30d7ac36fcf$var$load("lqFMg"),
    $75b6e30d7ac36fcf$var$load("h4XJj"),
    $75b6e30d7ac36fcf$var$load("fEFxJ"),
    $75b6e30d7ac36fcf$var$load("edaDG"),
    $75b6e30d7ac36fcf$var$load("eBRUf"),
    $75b6e30d7ac36fcf$var$load("bogQM"),
    $75b6e30d7ac36fcf$var$load("jq3Ai"),
    $75b6e30d7ac36fcf$var$load("h4Nf7"),
    $75b6e30d7ac36fcf$var$load("7f9Fz"),
    $75b6e30d7ac36fcf$var$load("8YSo7"),
    $75b6e30d7ac36fcf$var$load("dHMdi"),
    $75b6e30d7ac36fcf$var$load("lId0W"),
    $75b6e30d7ac36fcf$var$load("g9CVe"),
    $75b6e30d7ac36fcf$var$load("3w411"),
    $75b6e30d7ac36fcf$var$load("fSobj"),
    $75b6e30d7ac36fcf$var$load("74u2y"),
    $75b6e30d7ac36fcf$var$load("6wr18"),
    $75b6e30d7ac36fcf$var$load("kjZZD"),
    $75b6e30d7ac36fcf$var$load("9u7sS"),
    $75b6e30d7ac36fcf$var$load("1fem1"),
    $75b6e30d7ac36fcf$var$load("kHOMt"),
    $75b6e30d7ac36fcf$var$load("dRpV3"),
    $75b6e30d7ac36fcf$var$load("ffEVr"),
    $75b6e30d7ac36fcf$var$load("kknel"),
    $75b6e30d7ac36fcf$var$load("oTvoe"),
    $75b6e30d7ac36fcf$var$load("6u1hm"),
    $75b6e30d7ac36fcf$var$load("2vAWg"),
    $75b6e30d7ac36fcf$var$load("7cABH"),
    $75b6e30d7ac36fcf$var$load("4UuEP"),
    $75b6e30d7ac36fcf$var$load("dAdaw"),
    $75b6e30d7ac36fcf$var$load("2uVTT"),
    $75b6e30d7ac36fcf$var$load("1FeuN"),
    $75b6e30d7ac36fcf$var$load("lrSMb"),
    $75b6e30d7ac36fcf$var$load("hhss7"),
    $75b6e30d7ac36fcf$var$load("Wowvf"),
    $75b6e30d7ac36fcf$var$load("cJcjb"),
    $75b6e30d7ac36fcf$var$load("hJpvQ"),
    $75b6e30d7ac36fcf$var$load("bIPPg"),
    $75b6e30d7ac36fcf$var$load("lnKog"),
    $75b6e30d7ac36fcf$var$load("9ftJe"),
    $75b6e30d7ac36fcf$var$load("h3ABO"),
    $75b6e30d7ac36fcf$var$load("kC80R"),
    $75b6e30d7ac36fcf$var$load("7EorR"),
    $75b6e30d7ac36fcf$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lk93G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lk93G", function(module, exports) {

let $f8627e0aeed3fccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8627e0aeed3fccf$var$load("hJpvQ"),
    $f8627e0aeed3fccf$var$load("bIPPg"),
    $f8627e0aeed3fccf$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.b07b7c51.js.map
